var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("p", [
      _vm._v("Всего: "),
      _c("strong", [_vm._v(_vm._s(_vm.getAllOrders()))]),
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v("Смена: "),
      _c("strong", [
        _vm._v(
          _vm._s(_vm.getAllOrders(true)) +
            " (" +
            _vm._s(_vm.getAllOrders(true, true)) +
            "%)"
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }